import { isSameDay } from 'date-fns';

/**
 * Check if the given date is allowed based on the disabled dates.
 */
export const isDateAllowed = (date: Date, disabledDates: Date[]): boolean => {
  // Check if date is in the disabled dates
  if (disabledDates.some((d) => isSameDay(date, d))) {
    return false;
  }

  const enabledYears = new Set(
    disabledDates.map((disabledDate) => disabledDate.getFullYear())
  );

  // Check if date's year is in the enabled years
  if (!enabledYears.has(date.getFullYear())) {
    return false;
  }

  return true;
};
